module.exports = __webpack_public_path__ + "img/report_1.62d9905e.png";